/** @format */

import React from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getFlightTimesStart } from '../../redux/flightData/flightData.actions';
import { selectFlightTimes } from '../../redux/flightData/flightData.selector';
import CustomerByFlightRecord from './record.component';
import './customerByFlight-viz.styles.css';

class CustomerByFlightViz extends React.Component {
  componentDidMount() {
    // this.props.getFlightTimesStart();
  }

  render() {
    return (
      <div
        style={{
          width: 'clamp(70%, 900px, 90%)',
          visibility: this.props.hidden ? 'hidden' : 'visible',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="record-header">
          <div
            className="flightId"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            Flight
          </div>
          <div
            className="flightTime"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            STD
          </div>
          <div
            className="flightTime"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            ETD
          </div>
          <div
            className="flightTime"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            STA
          </div>
          <div
            className="flightTime"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            ETA
          </div>
          <div
            className="name"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            Name
          </div>
          <div
            className="phone-number"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            Phone
          </div>
          <div
            className="email-address"
            style={{
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            Email
          </div>
        </div>
        <div
          id="viz"
          style={{
            visibility: this.props.hidden ? 'hidden' : 'visible',
            height: `clamp(50px, ${this.props.customerCount * 50}px, 500px)`,
          }}
        >
          {this.props.selectedFlights !== undefined
            ? this.props.selectedFlights.map((flightid, j) => {
                if (
                  this.props.customerData !== null &&
                  this.props.customerData[flightid]
                ) {
                  return this.props.customerData[flightid].map(
                    (customer, i) => {
                      return (
                        <CustomerByFlightRecord
                          key={i + j}
                          customer={customer}
                          flightid={flightid}
                          flightTimes={this.props.flightTimes[flightid]}
                        />
                      );
                    }
                  );
                } else {
                  return null;
                }
              })
            : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  flightTimes: selectFlightTimes,
});

const mapDispatchToProps = (dispatch) => ({
  getFlightTimesStart: () => dispatch(getFlightTimesStart()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerByFlightViz);
